(function () {
  /* ---- Offset sticky filter bar below the sticky header ---- */
  const header = document.querySelector('.mt-header');
  const bar    = document.querySelector('.mt-coll-bar');

  if (header && bar) {
    const setOffset = () => { bar.style.top = header.offsetHeight + 'px'; };
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });
    window.addEventListener('scroll', setOffset, { passive: true });
  }

  /* ---- Filter panel open / close ---- */
  const overlay   = document.querySelector('.mt-filter-overlay');
  const panel     = document.querySelector('.mt-filter-panel');
  const openBtn   = document.querySelector('.mt-coll-bar__filter-btn');
  const closeBtn  = panel?.querySelector('.mt-filter-panel__close');

  const openPanel = () => {
    overlay?.classList.add('is-open');
    panel?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closePanel = () => {
    overlay?.classList.remove('is-open');
    panel?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  openBtn?.addEventListener('click', openPanel);
  closeBtn?.addEventListener('click', closePanel);
  overlay?.addEventListener('click', closePanel);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePanel();
  });

  /* ---- Sort — preserve active filter params when changing sort ---- */
  document.querySelector('.mt-coll-sort__select')?.addEventListener('change', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  /* ---- Price range filter submit on blur/enter ---- */
  const priceForm = document.querySelector('.mt-filter-price-form');
  if (priceForm) {
    const submitPrice = () => priceForm.submit();
    priceForm.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', submitPrice);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submitPrice(); });
    });
  }

  /* ---- Re-run on section load (theme editor) ---- */
  document.addEventListener('shopify:section:load', () => {
    if (header && bar) bar.style.top = header.offsetHeight + 'px';
  });
})();
